/**
 * SAM LAB REPORT Reducers
 */
import {
    SAMLABREPORT_ACTION,
    ALL_SAMLABREPORT,
    ADD_SAMLABREPORT,
    FETCH_SAMLABREPORT,
    DELETE_SAMLABREPORT,
    EDIT_SAMLABREPORT
} from 'Actions/types';


const INIT_STATE = {
    samlabreportlist: [],
    particularsamlabreport: [],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SAMLABREPORT_ACTION:
            return { ...state, loading: true };

        case ALL_SAMLABREPORT:
            return { ...state, loading: false, samlabreportlist: action.payload };

        case ADD_SAMLABREPORT:
            return { ...state, loading: false };

        case FETCH_SAMLABREPORT:
            return { ...state, loading: false, particularsamlabreport: action.payload };

        case EDIT_SAMLABREPORT:
            return { ...state, loading: false, particularsamlabreport: action.payload };

        case DELETE_SAMLABREPORT:
            return { ...state, loading: false };

        default: return { ...state };
 
    }
}
